import React, { useState } from "react";
import { Phone, MailIcon } from "lucide-react";
import { useLocation } from "react-router-dom";

const QuickSupport = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  if (location.pathname.includes("article-details")) {
    return null;
  }

  return (
    <>
      <button
        className="fixed top-1/2 right-0 z-40 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-700 shadow-lg rounded-l-full pl-3 pr-1 py-3 text-white font-bold transition-all"
        style={{borderTopLeftRadius: '30px', borderBottomLeftRadius: '30px', writingMode: "vertical-lr", textOrientation: "mixed", letterSpacing: "2px", height: 220}}
        onClick={() => setOpen(!open)}
        aria-label="Quick Support"
      >Expert Assistance</button>
      <div
        className={`fixed top-1/2 right-0 z-50 transform -translate-y-1/2 transition-transform duration-500 ease-in-out ${open ? 'translate-x-0' : 'translate-x-full'} w-64 bg-white shadow-2xl rounded-l-xl flex flex-col items-center py-8 px-2`}
        style={{borderTopLeftRadius: '30px', borderBottomLeftRadius: '30px'}}
      >
        <button
          className="absolute top-2 right-6 text-md font-bold p-1 rounded"
          onClick={() => setOpen(false)}
          aria-label="Close Quick Support"
        >✕</button>
        <a
          href="tel:+919315265493"
          className="w-5/6 my-2 py-3 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-700 font-semibold flex items-center justify-center gap-2 shadow transition"
        >
          <Phone className="w-5 h-5" /> Call Now
        </a>
        <a
          href="mailto:support@previewtax.com?subject=Inquiry Request&body=Hello, "
          className="w-5/6 my-2 py-3 rounded-full bg-red-100 hover:bg-red-200 text-red-700 font-semibold flex items-center justify-center gap-2 shadow transition"
        >
          <MailIcon className="w-5 h-5" /> Send Mail
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=919315265493&amp;text=Hello!+Preview+Tax,"
          target="_blank" rel="noopener noreferrer"
          className="w-5/6 my-2 py-3 rounded-full bg-green-700 hover:bg-green-800 text-white font-semibold flex items-center justify-center gap-2 shadow transition"
          aria-label="Chat on WhatsApp"
        >
          <img src="/wp_icon.webp" alt="WhatsApp Icon" className="w-5 h-5" /> WhatsApp
        </a>
      </div>
    </>
  );
};

export default QuickSupport;
